// named the same as the API!? Should be more like DiscussionForum or just Forum etc 
export enum DiscussionType{
    courseForum = 'CourseForum',
    courseDiscussion = 'CourseDiscussion',
    Groups = 'Groups'
}